import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyle } from './theme';
import { useAppContext } from './context/AppContext';
import ChooseModeComponent from './Components/ChooseMode';
import HeaderComponent from './Components/HeaderComponent';
import SingleAthleteTabContent from './Components/SingleAthleteTabContent';
import SingleAthleteTab from './Components/SingleAthleteTab';
import GroupAnalysisTabContent from './Components/GroupAnalysisTabContent';
import LoginPage from './Components/LoginPage';
import CoachAdminPage from './Components/CoachAdminPage';
import AthleteAdminPage from './Components/AthleteAdminPage';

// short term plan:
// 0. Restyle group analysis components 
// 1. Next level stepper is broken
// 2. input field spacing when in analysis mode must match when in capture\edit mode
// 3. norms input fields must also show but be empty when show norms is off
// 4. norms input fields are showing percentiles when test values are empty
// 5. input fields still have arrow buttons (remove)
// 6. norms fields text looks weird
// 7. integrate sessionsdropdown into athlete tab
// 8. benchmark rerendering and performance in browser

// Long term plan:
// 0. Handle exceptions (API fails) and delays (slow API calls) better
// 1. Move over to TypeScript
// 2. Improve responsiveness (use media queries, support mobile)
// 3. Improve UX (sidebar for settings, expand and standardize theme settings)
// 4. 

const App = () => {
  const { view, groupAnalysisMode } = useAppContext();

  const renderView = () => {
    switch (view) {
      case 'login':
        return <LoginPage />;
      case 'capture':
        return (
          <>
            <HeaderComponent />
            <ChooseModeComponent />
            <div className='AthleteTabContainer'>
              <SingleAthleteTab />
            </div>
            {groupAnalysisMode ? <GroupAnalysisTabContent /> : <SingleAthleteTabContent />}
          </>
        );
      case 'coachAdmin':
        return (
          <>
            <HeaderComponent />
            <CoachAdminPage />
          </>
        );
      case 'athleteAdminEdit':
      case 'athleteAdminCreate':
        return (
          <>
            <HeaderComponent />
            <AthleteAdminPage />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {renderView()}
    </ThemeProvider>
  );
};

export default App;